import apiService from 'shared/services/api';

export const deleteCompany = (id) => apiService({}).delete(`/companies/${id}`);
export const fetchCompanies = () => apiService({}).get(`/companies/short-list`);
